import { Link } from "react-router-dom";
import { CalendarClock, User, Flame } from "lucide-react";
import { StatusBadge } from "./kit";
import { deadlineState, fmtDate, num } from "../lib/constants";

const TONE = {
  late: "border-rose-500 bg-rose-50 ring-1 ring-rose-300",
  soon: "border-amber-400 bg-amber-50 ring-1 ring-amber-200",
  ok: "border-slate-200 bg-white",
  done: "border-slate-200 bg-white",
};
const TAG = {
  late: <span className="text-[11px] font-black uppercase px-2 py-0.5 rounded bg-rose-600 text-white">Telat</span>,
  soon: <span className="text-[11px] font-black uppercase px-2 py-0.5 rounded bg-amber-500 text-white">H-2</span>,
};

const DATE_TEXT = { late: "text-rose-700", soon: "text-amber-700", ok: "text-slate-600", done: "text-slate-600" };

export function OrderCard({ o }) {
  const st = deadlineState(o);
  const cups = [...new Set(o.items.map((i) => `${i.cup_type} ${i.cup_size}`))].join(", ");
  return (
    <Link to={`/order/${o.id}`} data-testid={`order-card-${o.order_no}`} data-deadline-state={st}
      className={`block p-4 rounded-2xl border-2 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-[box-shadow,transform] ${TONE[st]}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono font-bold text-sm text-slate-700">{o.order_no}</span>
        <div className="flex items-center gap-1.5">
          {o.priority !== "Normal" && <span className="inline-flex items-center gap-0.5 text-[11px] font-bold text-rose-600"><Flame className="w-3.5 h-3.5" />{o.priority}</span>}
          {TAG[st]}
        </div>
      </div>
      <div className="mt-2 text-lg font-extrabold text-slate-900 truncate">{o.customer?.name}</div>
      <div className="text-sm text-slate-600 truncate">{cups}</div>
      <div className="mt-1 text-2xl font-extrabold font-mono tabular-nums">{num(o.total_qty)} <span className="text-sm font-semibold text-slate-500">pcs</span></div>
      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <span className={`inline-flex items-center gap-1 font-semibold ${DATE_TEXT[st]}`}>
          <CalendarClock className="w-4 h-4" /> {fmtDate(o.deadline)}
        </span>
        <span className="inline-flex items-center gap-1 text-slate-600"><User className="w-4 h-4" /> {o.operator_name || "Belum ditugaskan"}</span>
      </div>
      <div className="mt-3"><StatusBadge status={o.status} /></div>
    </Link>
  );
}
